export const EXCMAGREEMENTCONSENT_SHOW_RESET = 'EXCMAGREEMENTCONSENT_SHOW_RESET'
export const EXCMAGREEMENTCONSENT_SHOW_SET_ERROR = 'EXCMAGREEMENTCONSENT_SHOW_SET_ERROR'
export const EXCMAGREEMENTCONSENT_SHOW_SET_RETRIEVED = 'EXCMAGREEMENTCONSENT_SHOW_SET_RETRIEVED'
export const EXCMAGREEMENTCONSENT_SHOW_TOGGLE_LOADING = 'EXCMAGREEMENTCONSENT_SHOW_TOGGLE_LOADING'
